<ion-header class="ion-no-border" mode="md">
  <ion-toolbar class="new-background-color ion-text-center" mode="md">
    <ng-container *ngIf="!byUrl">
      <ion-buttons slot="start" mode="md" id="i-buttons">
        <ion-button (click)="backFalse()" shape="round" id="i-button" mode="md">
          <ion-icon slot="start" name="previus-white"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ng-container>

    <ion-title [ngClass]="{'i-title': !byUrl}" mode="md" color="white">
      {{ dataStoragePoliticas.Descripcion }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="hasError && tipoError">
  <app-empty-data [tipoError]="tipoError"></app-empty-data>
</ion-content>

<ion-content *ngIf="!hasError" id="content-aviso" class="animated fast">
  <ion-grid>
    <ion-row id="row-logo">
      <ion-col size="12" class="fondo-azul">
        <ion-img [src]="'Icons.gepp-logo-white' | translate"></ion-img>
      </ion-col>
    </ion-row>

    <ion-row id="row-terminos">
      <ion-col size="12">
        <ion-card id="aviso">
          <ion-card-content>
            <div class="scrollComentario">
              <ion-label
                *ngIf="dataStoragePoliticas.Documento !== ''"
                [innerHTML]="dataStoragePoliticas.Documento | htmlSeguro"
              >
              </ion-label>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ng-container *ngIf="!byUrl">
      <ion-row id="row-aceptar">
        <ion-col size="12" id="boton">
          <ion-button size="large" (click)="backTrue()">
            {{ boton }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ng-container>
  </ion-grid>
</ion-content>
